import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DecisionTreeInfoWidget from '../../DTInfoWidget/DTInfoWidget';
import Loading, { LoadingWrapper } from '../../../LoadingComponent/LoadingComponent';
import { getDecisionNodeAtPath } from '../../../../extractFromState';
import { returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';
import {
  ContentContainer,
  ContentWrapper,
  DecisionTreeView,
  SubText,
  Title,
  TitleSection,
} from './DTSelectActionReason.styles';
import { ActionsButtonsWrapper } from '../../DecisionTree.styles';
import { BackButton, NextButton } from '../../../common/buttonsComponents';

export const AVAILABLE_FIELDS_CONFIG = {
  refundReason: {
    primaryReason: 'refundPrimaryReason',
    secondaryReason: 'refundSecondaryReason',
  },
  cancelOrRefundReason: {
    primaryReason: 'cancelOrRefundPrimaryReason',
    secondaryReason: 'cancelOrRefundSecondaryReason',
  },
  couponReason: {
    primaryReason: 'couponPrimaryReason',
    secondaryReason: 'couponSecondaryReason',
  },
  refundPrimaryReason: {
    primaryReason: 'refundPrimaryReason',
  },
  pointsPrimaryReason: {
    primaryReason: 'pointsPrimaryReason',
  },
};

export const DTSelectActionReasonView = (props) => {
  const { onNextButtonClick, isNextButtonActive } = props;

  const dispatch = useDispatch();

  const decisionNode = useSelector(getDecisionNodeAtPath);
  const isLoading = useSelector(
    (state) => state.ui?.loading?.isLoading && state.ui?.loading?.component === 'reasonContainer'
  );

  return (
    <DecisionTreeView>
      <ContentWrapper>
        <DecisionTreeInfoWidget />
      </ContentWrapper>
      {isLoading ? (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      ) : (
        <ContentContainer>
          <TitleSection>
            {decisionNode?.title && <Title>{decisionNode.title}</Title>}
            {decisionNode?.subText && <SubText>{decisionNode.subText}</SubText>}
          </TitleSection>
          {props.children}
        </ContentContainer>
      )}
      <ActionsButtonsWrapper>
        <NextButton active={isNextButtonActive} disabled={!isNextButtonActive} onClick={onNextButtonClick}>
          NEXT
        </NextButton>
        <BackButton onClick={() => dispatch(returnToPreviousMacroWizardPath())}>BACK</BackButton>
      </ActionsButtonsWrapper>
    </DecisionTreeView>
  );
};
